/* (c) Copyright Frontify Ltd., all rights reserved. */

export const SUBSCRIPT_PLUGIN = 'subscript-plugin';
